import { render, staticRenderFns } from "./BookFarmMap.vue?vue&type=template&id=1834dee2&"
import script from "./BookFarmMap.vue?vue&type=script&lang=js&"
export * from "./BookFarmMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports